import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import fr from './locales/fr.json';
import en from './locales/en.json';
import { initialLanguage, rememberSessionLanguage } from './urlLanguage';

i18n
  .use(LanguageDetector) // Détecte langue via navigator.language + localStorage
  .use(initReactI18next)  // Passe i18n à react-i18next
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    fallbackLng: 'fr',           // Si langue non supportée → FR par défaut
    supportedLngs: ['fr', 'en'], // Seules langues utilisables par l'interface
    load: 'languageOnly',         // Jamais de variante régionale (fr-FR, en-US…)
    debug: false,                 // true en dev pour logs dans console
    // URL publique : langue imposée par l'URL (/en/… anglais, sinon français).
    // Page privée : langue de l'onglet, sinon LanguageDetector (choix enregistré, navigateur).
    lng: initialLanguage(),
    interpolation: {
      escapeValue: false,         // React échappe déjà
    },
    detection: {
      order: ['localStorage', 'navigator'], // Priorité : localStorage > navigateur
      // Rien n'est enregistré automatiquement : une langue imposée par l'URL ne
      // remplace jamais le choix fait avec le bouton FR/EN (rememberChosenLanguage).
      caches: [],
      lookupLocalStorage: 'ridalo_lang',     // Clé utilisée : ridalo_lang
      // "fr-FR" → "fr", "en-US" → "en" (navigateur ou ancien choix enregistré)
      convertDetectedLanguage: (lng) => (lng || '').toLowerCase().split(/[-_]/)[0],
    },
  });

i18n.on('languageChanged', (lng) => rememberSessionLanguage(String(lng || '').slice(0, 2)));
rememberSessionLanguage(String(i18n.language || '').slice(0, 2));

export default i18n;
